import { actions as LKModalActions } from 'shared/LKModal'
import { MODAL_NAME, CLOSE_CHECK_MODAL } from './constants'

export const open = ({ ID, hash, name }) => LKModalActions.open({ name: name || MODAL_NAME, ID, hash })

export const openCloseCheck = ({ ID, hash }) => LKModalActions.open({ name: CLOSE_CHECK_MODAL, ID, hash })
